import React from "react";
import DealerDownstreamTable from "./DealerDownstreamTable";
import { useStructure } from "../../../contexts/StructureContext";

/**
 * Component to display the downstream.
 * @param {object} props - component props
 * @param {boolean} props.pendingOnly - filter for users with lifecycle === 1
 * @returns {React.Component} The component displaying the downstream.
 */
export default function DealersDownstream({ pendingOnly = false }) {
  const { downstream } = useStructure();
  const displayValues = pendingOnly
    ? downstream?.filter(user => user.refs_user_lifecycle_status_id === 1)
    : downstream;
  return (
    <div>
      <DealerDownstreamTable dealers={displayValues} />
    </div>
  );
}
